// Idioma de la cuenta en el panel: lo que ve el servidor (correos, avisos) y lo que
// ve la persona (la UI). Prioridad documentada en config.js:
//   elección local guardada > idioma de la cuenta > navegador > en.
import i18n, { LANGUAGE_CHOSEN_KEY, SUPPORTED_LANGUAGES } from './config';
import api from '../services/api';

/** Idioma activo de la UI como código base de uno de los 20 (es-ES -> es). */
export function currentLanguage() {
  const code = String(i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  return SUPPORTED_LANGUAGES.includes(code) ? code : 'en';
}

/** Cuerpo de las peticiones de login/alta: añade el idioma de la UI. */
export function withLanguage(body = {}) {
  return { ...body, language: currentLanguage() };
}

/** Marca que la persona eligió este idioma a mano en este navegador (gana al de la cuenta). */
export function markLanguageChosen(code) {
  try {
    localStorage.setItem(LANGUAGE_CHOSEN_KEY, code);
  } catch (_) { /* almacenamiento no disponible: la elección vale solo para esta sesión */ }
}

/**
 * Cambio explícito de idioma (selector): cambia la UI, lo recuerda en este navegador y,
 * con sesión iniciada, lo guarda en la cuenta (PUT /account/language) para que los
 * correos y avisos del servidor lleguen en él.
 */
export function chooseLanguage(code) {
  if (!SUPPORTED_LANGUAGES.includes(code)) return;
  i18n.changeLanguage(code);
  markLanguageChosen(code);
  if (localStorage.getItem('authToken')) {
    api.put('/account/language', { language: code })
      .catch((err) => console.warn('[i18n] No se pudo guardar el idioma en la cuenta:', err.message));
  }
}

/**
 * El servidor devuelve el idioma de la cuenta (GET /account/security). Se adopta solo si
 * la persona no ha elegido otro en este navegador; no se guarda como elección local.
 */
export function adoptAccountLanguage(code) {
  if (!code || !SUPPORTED_LANGUAGES.includes(code)) return;
  let chosen = null;
  try { chosen = localStorage.getItem(LANGUAGE_CHOSEN_KEY); } catch (_) { /* sin almacenamiento */ }
  if (chosen) return;
  if (currentLanguage() !== code) i18n.changeLanguage(code);
}
